<template>
	<router-link to="/settings/subscriptions">
		<UiGridTile clickable>
	      <UiRow gap="2" align="center">
	        <a>Manage Subscription</a>
	      </UiRow>
	    </UiGridTile>
	</router-link>
</template>